import InternalServerErrorPageComponent from "./ui";

export const InternalServerErrorPage = () => (
	<InternalServerErrorPageComponent />
);
